import { client as request } from "./request";

export interface Stamp {
  id: number;
  icon: string;
  image: File | null;
  width: string;
  height: string;
  top: string;
  left: string;
  officeId: string;
}

/**
 * Stampを保存する
 */
export async function saveStamp(data: FormData) {
  const res = await request.post("save_stamp.php", data);
  return res.id;
}

/**
 * スタンプを削除する
 */
export async function deleteStamp(id: any) {
  await request.post("delete_stamp.php", {}, { id });
}

/**
 * IDでスタンプを取得
 */
export async function getStamp(id: number) {
  const res = await request.get("get_stamp.php", { id });
  return res;
}
